//import ReactToPdf from "react-to-pdf";
import ReactToPrint, { PrintContextConsumer } from "react-to-print";
import React,{Component} from "react";
import "./header/Header.css";
import "../scss/general.css";
import Cookies from "universal-cookie";
import Moment from "moment";
import logo from "./images/loading.gif";
import logonorecord from "./images/recordnotfound.png";
import logoverified from "./images/verified.png";
import BusyModal from "./modalwait";
const cookies = new Cookies();
const axios = require("axios");
const ref = React.createRef();
export default class AdminMedicalForm extends Component {
    constructor(props) {
        super(props);
        this.state = {input:{},
            apipath:"",
            myitems: [],
            isLoaded: true,
            isForm: "none",
            FormID:"",
            errortext:"",errorcss:"",
            errortextsave:"",
            paidlogo:"",
            buttonED:false,buttonpdf:"block",buttonverify:"block",
            divbutton:"<button onClick={this.handleVerify(0)} style={{background: 'linear-gradient(to bottom , #ffffff 0%, black 100%)'}}>Check / Verify</button>",
            ErrMsg:"", //<img src={logo} alt=""/>,
            ErrMsg2:"",
            bformlogo:"",
        }
        this.currencyFormat = this.currencyFormat.bind(this);
        this.handleFocus = this.handleFocus.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleVerify = this.handleVerify.bind(this);
      }
      componentDidMount(){
        this.setState({apipath:this.props.apipath});
      }
      // handle input change

  handleInputChange = (e)=> {
    this.setState({FormID:e.target.value});
  }
  handleFocus(event){event.target.select();}
  
  handleVerify(){
        document.body.style.cursor="wait";
        this.setState({buttonED:true,ErrMsg2:<BusyModal/>,ErrMsg:<img src={logo} alt=""/>});
        axios({
            method: "post",
//            url:    cookies.get("phpclass")+"/index.php/user/approveMedical/"+this.state.FormID,
            url:  this.state.apipath +"/index.php/user/approveMedical/"+this.state.FormID,
            heaer: {"Content-Type":"multipart/for-data"}
        })
        .then((response)=>{
            if(response.data === "1")
            {
                document.body.style.cursor="default";
                this.setState({ErrMsg2:"",buttonED:true,divbutton:<img src={logoverified}/>,buttonpdf:false,buttonverify:true,errortextsave:""});
            }
            else
            {
                document.body.style.cursor="default";
                this.setState({ErrMsg2:"",errortextsave:'Unable to varify this time, please try later.',errorcss:"labelerror"});
            }

        })
        .catch=()=>{
            document.body.style.cursor="default";
            this.setState({ErrMsg:<img src={logonorecord} alt=""/>,isOpen:false});

        };
  }
    currencyFormat(num) {
        let cnum=Number(num);
            return cnum.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
     }
    handleSubmit(){
        this.setState({errortext:"",ErrMsg:<img src={logo} alt=""/>,myitems:[],isForm:"none"});

        if(this.state.FormID.length !== 0)
        {
            document.body.style.cursor="wait";
            axios({
                    method: 'post',
//                    url: cookies.get("phpclass")+'/index.php/user/Adminmedicalform/'+this.state.FormID,
                    url: this.state.apipath +'/index.php/user/Adminmedicalform/'+this.state.FormID,
                    headers: {'Content-Type': 'multipart/form-data'}
                })
                .then((response)=> {
                    console.log(response.data);
                    if(response.data.length == 0)
                    {
                        this.setState({ErrMsg:<img src={logonorecord} alt=""/>});
                        document.body.style.cursor="default";            
                    }
                    else
                    { 
                        document.body.style.cursor="default";
                        let input = this.state.input;
                        let bformpath=response.data[0]["imagename"];
                        input["Name"] = response.data[0]["NAME"];
                        input["Designation"] = response.data[0]["DESIG"];
                        input["Emp_ID"] = response.data[0]["Emp_Id"];
                        input["Location"] = response.data[0]["location"];
                        input["DateClaim"] = response.data[0]["DateClaim"];
                        input["Ceiling"] = response.data[0]["Ceiling"];
                        input["Remaining"] = response.data[0]["Remaining"];
                        input["ClaimID"] = this.state.FormID;
                        console.log(response.data[0]["imagename"]);
                        this.setState({input,ErrMsg:"", bformlogo:response.data[0]["imagename"], isLoaded: true, isForm:"block", myitems: response.data, ErrMsgs:"",buttonED: false});
                        if(response.data[0]['status'] === 1)
                            this.setState({paidlogo:logoverified,buttonpdf:"block",buttonverify:"none", divbutton:<span style={{fontSize:'12pt',color:'red'}}>This claim has already been paid.</span>});
                        else
                            this.setState({paidlogo:"",buttonpdf:"none",buttonverify:"block",divbutton:<button onClick={this.handleVerify} style={{background: 'linear-gradient(to bottom , #ffffff 0%, black 100%)'}} disabled={this.state.buttonED}>Check / Verify</button>});
                    
                    }
                })
                .catch=()=> {
                    document.body.style.cursor="default";
                    this.setState({ErrMsg:<img src={logonorecord} alt=""/>});

                }; 
        }
        else
        {
            this.setState({errortext:"Enter Form ID"});
        }
    }
    render(){
        let fileName=this.state.input["ClaimID"]+"-medical.pdf";
        let items=this.state.myitems;
        let CDate,MDate,TDate = "";
        let CAmt = 0;
        let MAmt = 0;
        let TAmt = 0;
        let isForm = this.state.isForm;
        let isLoaded = this.state.isLoaded;
        return (
        <div width="100%" align="center" >
                <br></br>
            <div className="inner-profile33" >
  {/*}          <span className="box-title">Medical Form</span>*/}
            <div className="inner-profile2" >
                <label>Form ID: </label>
                <input style={{width:"110px",paddingRight:20}} autoFocus="autofocus" name="PForm" placeholder="Form Id" onChange={this.handleInputChange} onFocus={ this.handleFocus}/>
                <button onClick={this.handleSubmit} >Submit</button>
                <span className="labelerror">{this.state.errortext}</span>

            </div>
            <img src={this.state.bformlogo} style={{width:"50px", height:"75px", float:"right",cursor:"pointer"}} data-bs-toggle="modal"  data-bs-target="#imageModal" />
            <div class="modal fade" id="imageModal">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-body text-center">
                            <img src={this.state.bformlogo} class="img-fluid" alt="Form Logo" />
                        </div>
                    </div>
                </div>
            </div>

            <br></br>
            <div style={{display:isForm,textAlign:"left",width:"100%"}} >  
                <div ref={el => (this.componentRef = el)}>
                <table style={{ width:"100%",  marginTop :75}} id="DReport" name="DReport"  >
                <tr >
                <div width="100%"  >
                    <div style={{width:"60%", float:"left"}}>
                    <h6>
                    <table className="mtable">
                        <tbody>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Claim ID:</td>
                        <td style={{width:"300px",textAlign:"left",fontSize:12}}>{this.state.input["ClaimID"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Employee's ID:</td>
                        <td style={{width:"300px",textAlign:"left",fontSize:12}}>{this.state.input["Emp_ID"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Employee's Name:</td>
                        <td style={{width:"300px",textAlign:"left",fontSize:12}}>{this.state.input["Name"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Designation:</td>
                        <td style={{width:"300px",textAlign:"left",fontSize:12}}>{this.state.input["Designation"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Location:</td>
                        <td style={{width:"300px",textAlign:"left",fontSize:12}}>{this.state.input["Location"]}</td>
                        </tr>
                        <tr>
                        <td style={{width:"200px",fontStyle: "normal",fontSize:12}}>Date:</td>
                        <td style={{width:"300px",textAlign:"left",fontSize:12}}>{Moment(this.state.input["DateClaim"]).format("DD/MM/YYYY")}</td>
                        </tr>
                        </tbody>
                    </table>
                    </h6>  

                    <b>   
                    <span style={{width:"200px"}}>Ceiling  : {this.currencyFormat(this.state.input["Ceiling"])}</span><span style={{width:"400px",marginLeft:"50px"}}>Remaining: {this.currencyFormat(this.state.input["Remaining"])}</span></b>
                    </div>
                    <div style={{width:"20%", float:"left"}}>
                        <img src={this.state.paidlogo} />
                    </div>
                    <table className="mtable">
                        <thead >
                            <tr>
                                <th className="mth" rowSpan="2" ><p style={{textAlign:'left'}}>PATIENT NAME</p></th>
                                <th className="mth" rowSpan="2"><p style={{textAlign:'center'}}>RELATION</p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>CONSULTATION</p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>MEDICINES </p></th>
                                <th className="mth" colSpan="2"><p style={{textAlign:'center'}}>TESTS/LAB.</p></th>
                                <th className="mth" colSpan="2" rowSpan="2"><p style={{textAlign:'center'}}>TOTAL</p></th>
                            </tr> 
                            <tr>
                                <th className="mth" >Amount</th>
                                <th className="mth">Date</th>
                                <th className="mth">Amount</th>
                                <th className="mth">Date</th>
                                <th className="mth">Amount</th>
                                <th className="mth">Date</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((x, i) => {
                            CAmt += Number(x.Const_amt);
                            TAmt += Number(x.Test_amt);
                            MAmt += Number(x.Med_amt);

                            if(Number(x.Const_amt) === 0) 
                                CDate= "-";
                            else
                                CDate=Moment(x.Const_date).format("DD/MM/YYYY")
                            if(Number(x.Med_amt) === 0) 
                                MDate= "-";
                            else
                                MDate=Moment(x.Med_date).format("DD/MM/YYYY")
                            if(Number(x.Test_amt) === 0) 
                                TDate= "-";
                            else
                                TDate=Moment(x.Test_date).format("DD/MM/YYYY")
                                return(
                                    <tr key={i} height="40px">
                                        <td className= "mtdleft" >
                                            {x.PName}
                                        </td>
                                        <td className="mtdcenter">
                                            {x.Relation}
                                        </td>
                                        <td className="mtdright" >
                                            {this.currencyFormat(x.Const_amt)}                
                                        </td>
                                        <td className="mtdcenter">
                                            {CDate}
                                        </td>
                                        <td className="mtdright" >
                                            {this.currencyFormat(x.Med_amt)}
                                        </td>
                                        <td className="mtdcenter">
                                            {MDate}
                                        </td>
                                        <td className="mtdright">
                                            {this.currencyFormat(x.Test_amt)}
                                        </td>
                                        <td className="mtdcenter">
                                            {TDate}
                                        </td>
                                        <td className="mtdright">
                                            {this.currencyFormat(Number(x.Const_amt)+Number(x.Med_amt)+Number(x.Test_amt))}
                                        </td>
                                    </tr>
                                );
                                })}            
                        </tbody>
                        <tr style={{height:"40px", border: "1.5px solid rgb(161, 159, 159)"}}>
                            <td className="mtdleft2" colSpan="2">
                                TOTAL
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(CAmt)}                
                            </td>
                            <td className="mtdcenter2" colSpan="2" >
                                {this.currencyFormat(MAmt)}
                            </td>
                            <td className="mtdcenter2" colSpan="2">
                                {this.currencyFormat(TAmt)}
                            </td>
                            <td className="mtdright2" colSpan="3">
                                {this.currencyFormat(Number(CAmt)+Number(MAmt)+Number(TAmt))}
                            </td>
                        </tr>
                        <tr height="40px"></tr>
                        <tr height="120px">
                            <td className="mtdcenterH" rowSpan="10" colSpan="3">REQUESTED BY</td>
                            <td className="mtdcenterH" rowSpan="10" colSpan="3">CHECKED BY</td>
                            <td className="mtdcenterH" rowSpan="10" colSpan="3">APPROVED BY</td>
                        </tr> 
                    </table>
                    <font className="Pclass"><br></br>
                    <span style={{height:"100px"}}>Please attach all original Doctor's prescriptions and receipt. All amounts should be rounded to the nearest rupee.</span><br></br><br></br>
                    <label>REMARKS:_____________________________________________</label><br></br><br></br>
                        
                    </font>

                    <div>
                    </div>
                </div>
            </tr>
            </table>
            </div>
            <div style={{textAlign:"center", width:"100%", display:this.state.buttonpdf}}>
            <ReactToPrint content={() => this.componentRef}>
                <PrintContextConsumer>
                        {({ handlePrint }) => (
                            <button onClick={handlePrint} style={{background: "linear-gradient(to bottom , #ffffff 0%, black 100%)"}}>Send to print!</button>
                        )}
                </PrintContextConsumer>
            </ReactToPrint>                
            </div>
            <div style={{align:"center", width:"50%", display:this.state.buttonverify}}>
                {this.state.divbutton}
            </div>
            <div style={{width:"80%",float:"center"}}>
                <span className={this.state.errorcss}><b>{this.state.errortextsave}</b></span>
            </div>

    </div>
    </div>
    <br></br><br></br><br></br>
    {this.state.ErrMsg}
    </div>
 /*   </div>*/
    );
}
}